export const ASSISTANT_BUSINESS_CASE_CONTEXT_REFRESH_INTERVAL_MS = 60_000;
